import { NgModule } from '@angular/core';
import { UserService } from './user.service';
import { UserBackend } from './user.backend';

@NgModule({
  providers: [UserService, UserBackend],
})
export class UserModule {}
